// *****************
// *****************

// Single Truck Page Diesel Card Banner can be found in Workspace.js file.

// *****************
// *****************

import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import * as logger from '../../../logger';
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    Typography
} from '@material-ui/core';
import { SingleVehicleCss as useStyles } from './VehicleCss'
import { singleTruck, deleteVehicle, PandL, Expenses, marketVehicleExpenses, getAllVehicleTypeConfigs, FetchExpenseDetails } from '../../../store/actions/vehicleActionCreator';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import DateFilter from "../../components/FilterComponent/DateFilter";
import TripBookFilter from "../../components/FilterComponent/TripBookFilter";
import { getTripDateFilterValues, getDateStringDDMMM, numberFormat, getDateInStringDDMMMYYYY, getDateFilterStringDDMMM } from '../../../utils/utils';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { TripBookIconDweb, DocumnetsIconDweb, DriverIconDweb, EmiBookIconDweb, FuelBookIconDweb, MaintenanceBookIconDweb, TripsAndExpensesDweb, FuelBunkGreen } from '../../../components/icons';
import SearchIcon from '@material-ui/icons/Search';
import EditTruck from '../Vehicles/AddVehicle';
import ComingSoonModal from '../../components/ComingSoonModal/comingSoonModal';
import DeleteExpenseDialog from '../../components/VehicleDialogs/DeleteExpenseDialog';
import AddFuelExpenseDialog from '../../components/VehicleDialogs/AddFuelExpenseDialog';
import AddMaintainanceExpenseDialog from '../../components/VehicleDialogs/AddMaintainanceExpenseDialog';
import AddDriverExpenseDialog from '../../components/VehicleDialogs/AddDriverExpenseDialog';
import TripBook from './TruckBooks/TripBook';
import FuelBook from './TruckBooks/FuelBook';
import MaintenanceBook from './TruckBooks/MaintenanceBook';
import DriverBook from './TruckBooks/DriverBook';
import DocumentBook from './TruckBooks/DocumentBook';
import EmiBook from './TruckBooks/EmiBook';
import CustomDateFilterDialog from '../../components/FilterComponent/CustomDateFilter';
import SingleVehicleMonthlyReport from './SingleVehicleMonthlyReport';
import {
    TRIP_STATUS_LABELS, TRIP_FILTER_STATUS_MAPPING
} from "../../../store/constants";
import TripStatusFilter from "../../components/FilterComponent/TripStatusFIlter";
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize } from '../../../paginationVariables';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DriverDetailsDialog from '../../components/DieselCardComponents/DriverDetailsDialog';
import Workspace from "../../components/Workspace/Workspace"

const SingleVehicle = ({ user, dispatchGetSingleTruck, dispatchVehicleTypesConfig, vehicle, dispatchDeleteVehicle, dispatchGetPandL, dispatchGetTripExpenses, dispatchFetchSingleExpense, dispatchGetMarketTrukExpenses }) => {

    const [singleTruckData, setSingleTruckData] = useState({});
    const [deleteTruckDialog, setDeleteTruckDialog] = useState(false);
    const [dateFilterValue, setDateFilterValue] = useState("ALL_MONTHS");
    const [tripBookFilterValue, setTripBookFilterValue] = useState([]);
    const [truckLog, setTruckLog] = useState([]);
    const [changeFlag, setChangeFlag] = useState(false);
    const [editVehicleOpen, toggleEditVehicleOpen] = React.useState(false);
    const [comingSoonModalOpen, setComingSoonModalOpen] = useState(false);
    const [parentType, setParentType] = useState(false);
    const [deleteExpenseDialogOpen, setDeleteExpenseDialogOpen] = useState(false);
    const [expenseIdValue, setExpenseIdValue] = useState("");
    const [editFuelExpense, setEditFuelExpense] = useState(false);
    const [editMaintenanceExpense, setEditMaintenanceExpense] = useState(false);
    const [editDriverExpense, setEditDriverExpense] = useState(false);
    const [singleExpenseDetails, setSingleExpenseDetails] = useState({});
    const [tripBookOpen, setTripBookOpen] = useState(false);
    const [fuelBookOpen, setFuelBookOpen] = useState(false);
    const [maintenanceBookOpen, setMaintenanceBookOpen] = useState(false);
    const [driverBookOpen, setDriverBookOpen] = useState(false);
    const [documentBookOpen, setDocumentBookOpen] = useState(false);
    const [emiBookOpen, setEmiBookOpen] = useState(false);
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({});
    const [monthlyReportDialog, setMonthlyReportDialog] = useState(false);
    const [selectedFilterStatus, setSelectedFilterStatus] = useState("ALL");
    const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
    const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
    const [fuelCardActivation, setFuelCardActivation] = useState(false);

    const handleTripStatusValue = (value) => {
        setSelectedFilterStatus(value);
        setChangeFlag(true);
    }

    const [name, setName] = useState("");

    const handleEditVehicleOpen = () => {

        dispatchGetSingleTruck(vehicleId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Successfull ");
                    toggleEditVehicleOpen(true);
                }
            },
            () => {
                logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Failed");
            }
        );

    };
    const classes = useStyles();

    let history = useHistory();
    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let vehicleId = path && path[path.length - 1] ? path[path.length - 1] : "";

    const handleEditVehicleClose = () => {
        toggleEditVehicleOpen(false);
        fetchSingleData(vehicleId)
    };
    const handleVehicleUpdate = (status, response) => {
        toggleEditVehicleOpen(false);
        fetchSingleData(vehicleId)
    }
    var dateFilterValueUtil = getTripDateFilterValues();

    var pandl = vehicle.pandl ? vehicle.pandl : {};
    const getPaginatedData = () => {
        fetchSingleData(vehicleId, true)
    }
    const fetchSingleData = (vehicleId, pagination) => {
        var startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;

        var PandLdata = {
            vehicleId: vehicleId,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: vehicleId,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: [],
            tripStatus: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus],
            pageNo: defaultPageNo,
            pageSize: defaultPageSize,
        };
        if (pagination) {
            expenseData = {
                ...expenseData,
                pageNo: currentPageNo + 1,
                pageSize: currentPageSize,
                merge: true
            }
        }



        dispatchGetSingleTruck(vehicleId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    let vehicleOwner = data && data.response && data.response.ownershipType ? data.response.ownershipType : {};
                    logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Successfull ");
                    dispatchGetPandL(PandLdata, null,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Single Vehicle Component Dweb", "Get P and L report Successfull");
                                if (vehicleOwner == 'HIRED') {
                                    dispatchGetMarketTrukExpenses(expenseData, null,
                                        (data) => {
                                            if (data && data.status && data.status.code == 200) {
                                                logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");

                                            }
                                        },
                                        () => {
                                            logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                        },
                                    )
                                } else {
                                    dispatchGetTripExpenses(expenseData, null,
                                        (data) => {
                                            if (data && data.status && data.status.code == 200) {
                                                logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");

                                            }
                                        },
                                        () => {
                                            logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                        },
                                    )
                                }

                            }
                        },
                        () => {
                            logger.log("Single Vehicle Component Dweb", "Get P and L report Failed");
                        },
                    )
                }
            },
            () => {
                logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Failed");
            }
        );
    }

    useEffect(() => {
        dispatchVehicleTypesConfig(() => {
            fetchSingleData(vehicleId)
        })
    }, []);

    useEffect(() => {
        if (vehicle.singleTruck) {
            setSingleTruckData(vehicle.singleTruck);
        }
        if (vehicle.singleExpenseDetails) {
            setSingleExpenseDetails(vehicle.singleExpenseDetails)
        }
    }, [vehicle.singleTruck, vehicle.singleExpenseDetails]);

    useEffect(() => {

        let list = [];
        if (vehicle && vehicle.expenses && vehicle.expenses.singleVehicleMerge) {
            list = [
                ...truckLog
            ]
        }
        let data = vehicle.expenses.expenseLog;

        if (vehicle.expenses) {
            for (let i = 0; i < data?.length; i++) {
                for (let j = 0; j < data[i].lineItems.length; j++) {
                    let exp = data[i].lineItems[j];
                    if (exp && exp.expenseParams && exp.expenseParams.length > 0) {
                        if (exp.expenseParams[1]) {
                            exp.tripRoute = exp.expenseParams[1]
                        }
                        if (exp.expenseParams[2]) {
                            exp.tripParty = exp.expenseParams[2]
                        }
                    }
                    list.push(exp)
                }
            }
        }
        setTruckLog(list.filter((log) => {
            if (singleTruckData && singleTruckData.ownershipType && singleTruckData.ownershipType != "HIRED") {
                return true
            } else {
                if (log && log.expenseParentType && log.expenseParentType === 'trip') {
                    return true
                } else {
                    return false
                }
            }
        }));
    }, [vehicle.expenses]);

    useEffect(() => {
        if (changeFlag) {
            setCurrentPageNo(defaultPageNo)
            var startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;

            var PandLdata = {
                vehicleId: vehicleId,
                startDateRange: {
                    startTimeEpoch: startDateRange.startTimeEpoch,
                    endTimeEpoch: startDateRange.endTimeEpoch
                }
            };

            var expenseData = {
                vehicleId: vehicleId,
                startDateRange: {
                    startTimeEpoch: startDateRange.startTimeEpoch,
                    endTimeEpoch: startDateRange.endTimeEpoch
                },
                expenseParentType: tripBookFilterValue,
                tripStatus: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus],
                pageNo: defaultPageNo,
                pageSize: defaultPageSize,
            };

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                PandLdata.startDateRange.startTimeEpoch = customFilterValue.startTimeEpoch;
                PandLdata.startDateRange.endTimeEpoch = customFilterValue.endTimeEpoch;
                expenseData.startDateRange.startTimeEpoch = customFilterValue.startTimeEpoch;
                expenseData.startDateRange.endTimeEpoch = customFilterValue.endTimeEpoch;
            }

            dispatchGetPandL(PandLdata, null,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Single Vehicle Component Dweb", "Get P and L report Successfull");
                        if (singleTruckData && singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED") {
                            dispatchGetMarketTrukExpenses(expenseData, null,
                                (data) => {
                                    if (data && data.status && data.status.code == 200) {
                                        logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");

                                    }
                                },
                                () => {
                                    logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                },
                            )
                        } else {
                            dispatchGetTripExpenses(expenseData, null,
                                (data) => {
                                    if (data && data.status && data.status.code == 200) {
                                        logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");

                                    }
                                },
                                () => {
                                    logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                },
                            )
                        }
                    }
                },
                () => {
                    logger.log("Single Vehicle Component Dweb", "Get P and L report Failed");
                },
            )

        }
    }, [dateFilterValue, tripBookFilterValue, customFilterValue, selectedFilterStatus]);
    const muiData = truckLog ? truckLog : [];

    const muiColumns = [
        {
            name: "transactionDate",
            label: "Date",
            options: {
                filter: true,
                sort: true,
                // customBodyRender: (value, tableMeta, updateValue) => {
                //     return <span>{value}</span>
                // }
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (rowIndex === muiData.length - 3) {
                        return (
                            <Fragment>
                                <Waypoint
                                    onEnter={() => {
                                        if (vehicle && vehicle.expenses && vehicle.expenses.maxPage && vehicle.expenses.maxPage != currentPageNo) {
                                            getPaginatedData()
                                            setCurrentPageNo(currentPageNo + 1)
                                        }
                                    }}
                                />
                                <div>{truckLog[dataIndex] && truckLog[dataIndex].expenseDate ? truckLog[dataIndex].expenseDate : ""}</div>
                            </Fragment>
                        );
                    } else {
                        return (
                            <div>{truckLog[dataIndex] && truckLog[dataIndex].expenseDate ? truckLog[dataIndex].expenseDate : ""}</div>
                        )
                    }
                }
            },
        },
        {
            name: "expenseName",
            label: singleTruckData.ownershipType && singleTruckData.ownershipType === "HIRED" ? "Route" : "Reason",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let expLog = truckLog[dataIndex];
                    if (singleTruckData.ownershipType && singleTruckData.ownershipType === "HIRED") {
                        return (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className={classes.fw300}>{truckLog[dataIndex] ? truckLog[dataIndex].expenseName : ""}</div>
                                    <FiberManualRecordIcon className={classes.indicator} />
                                    <div>{truckLog[dataIndex] && truckLog[dataIndex].expenseParams && truckLog[dataIndex].expenseParams[1] ? truckLog[dataIndex].expenseParams[1] : ""}</div>
                                </div>
                        )
                    } else {
                        return (
                            <div className={classes.divV6} style={{ alignItems: 'center' }}>
                                <div className={classes.fw300}>{truckLog[dataIndex] ? truckLog[dataIndex].expenseName : ""}</div>
                                {truckLog && truckLog[dataIndex] && truckLog[dataIndex].isTripExpense &&
                                    <div className={classes.fromATrip}>From a trip{truckLog && truckLog[dataIndex] && truckLog[dataIndex].trip_start_date ? ` started on ${getDateStringDDMMM(truckLog[dataIndex].trip_start_date)}` : ""}</div>
                                }
                                {truckLog && truckLog[dataIndex] && ((truckLog[dataIndex].expenseParentType ? truckLog[dataIndex].expenseParentType == "fastag" : false)
                                    || (truckLog[dataIndex].expenseType ? truckLog[dataIndex].expenseType.toLowerCase() == "fuel_card_recharge" : false) ||
                                    (truckLog[dataIndex].expenseType ? truckLog[dataIndex].expenseType.toLowerCase() == "fuel_refill" : false)
                                ) &&
                                    <div><CheckCircleIcon className={classes.doneIcon} /></div>
                                }
                                {expLog && expLog.tripParty ? <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <FiberManualRecordIcon className={classes.indicator} /><Typography className={classes.txType}>{expLog.tripParty}</Typography>
                                </div> : ''}
                                {expLog && expLog.tripRoute ? <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <FiberManualRecordIcon className={classes.indicator} /><Typography className={classes.txType}>{expLog.tripRoute}</Typography>
                                </div> : ''}
                            </div>
                        )
                    }
                }
            },
        },
        {
            name: "amount",
            label: singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED" ? "Revenue" : "Expenses",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED") {
                        return (<div className={classes.revenue}>
                            {truckLog[dataIndex] && truckLog[dataIndex].revenue ? numberFormat(truckLog[dataIndex].revenue) : ""}</div>
                        )
                    } else {
                        return (
                            <>
                                {truckLog[dataIndex] && truckLog[dataIndex].expenseParentType != "trip" && Number(truckLog[dataIndex].amount) > 0 &&
                                    <div className={classes.fw300}>-{numberFormat(truckLog[dataIndex].amount)}</div>
                                }
                            </>
                        )
                    }
                }
            },
        },
        {
            name: "amount",
            label: singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED" ? "Expense" : "Revenue",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED") {
                        return (<div className={classes.revenue}>
                            {truckLog[dataIndex] && truckLog[dataIndex].expense ? numberFormat(truckLog[dataIndex].expense) : ""}</div>
                        )
                    } else {
                        return (
                            <>
                                {truckLog[dataIndex] && truckLog[dataIndex].expenseParentType == "trip" && Number(truckLog[dataIndex].amount) > 0 &&
                                    <div className={classes.revenue}>{numberFormat(truckLog[dataIndex].amount)}</div>
                                }
                            </>
                        )
                    }
                }
            },
        },
        {
            name: "amount",
            label: singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED" ? "Profit" : "Action",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED") {
                        return (<div className={classes.revenue}>
                            {truckLog[dataIndex] && truckLog[dataIndex].profit ? numberFormat(truckLog[dataIndex].profit) : ""}</div>
                        )
                    } else {
                        return (
                            <>
                                {truckLog[dataIndex] && truckLog[dataIndex].expenseParentType != "trip" && truckLog[dataIndex].expenseParentType != "fastag" && (truckLog[dataIndex].expenseType ? truckLog[dataIndex].expenseType.toLowerCase() != "fuel_card_recharge" : false)
                                    && (truckLog[dataIndex].expenseType ? truckLog[dataIndex].expenseType.toLowerCase() != "fuel_refill" : false)
                                    &&
                                    < div className={classes.divV9} >
                                        <div>
                                            <IconButton variant="outlined" className={classes.iconButtonV1} onClick={() => handleEditExpense(dataIndex)}><EditIcon className={classes.editIcon} /></IconButton>
                                        </div>
                                        <div>
                                            <IconButton variant="outlined" className={classes.iconButtonV2} onClick={() => handleDeleteExpense(dataIndex)}><DeleteIcon className={classes.deleteIcon} /></IconButton>
                                        </div>
                                    </div >
                                }
                                {truckLog[dataIndex].expenseParentType == "trip" &&
                                    <div>
                                        <Button variant="outlined" className={classes.viewTripButton} onClick={() => handleRedirectTrip(dataIndex)}>View Trip</Button>
                                    </div>
                                }
                            </>
                        )
                    }
                }
            },
        }
    ];
    if (singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED") {
        muiColumns.push(
            {
                name: "amount",
                label: "Status",
                options: {
                    filter: true,
                    sort: false,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        let value = truckLog[dataIndex] && truckLog[dataIndex].status ? truckLog[dataIndex].status : ""
                        return (
                            <>
                                <div className={classes.statusDiv}> <FiberManualRecordIcon
                                    className={classes[value + '_BULLET']}
                                ></FiberManualRecordIcon><div className={classes[value]}>{TRIP_STATUS_LABELS[value]}</div></div>

                            </>
                        )
                    }
                },
            })
    }
    const options = {
        rowsPerPage: 100,
        pagination: false,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: 'calc(100vh - 440px)',
        selectableRows: 'none',
        searchOpen: false,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        searchProps: {
            variant: "outlined",
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        onRowClick: (data, row) => {
            if (row.dataIndex || row.dataIndex == 0) {
                //let tableData = muiData[row.dataIndex];
                if (singleTruckData && singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED") {
                    handleRedirectTrip(row.dataIndex);
                }
            }
        },
        searchPlaceholder: 'Search Trucks',
        textLabels: {
            body: {
                noMatch: "Sorry, no transactions found",
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };

    const handleRedirectTrip = (index) => {
        let selectedData = muiData && muiData[index] ? muiData[index] : "";
        if (selectedData && selectedData.journeyId) {
            history.push({
                pathname: `/trips/view/${selectedData.journeyId}`,
                state: {
                    id: 7,
                    tripView: true,
                    pageTitle: 'Trip Details',
                    pageSubTitle: singleTruckData && singleTruckData.vehicleNumber ? singleTruckData.vehicleNumber : ''
                }
            });
        }
    }

    const handleDeleteExpense = (index) => {
        let selectedData = muiData && muiData[index] ? muiData[index] : "";
        if (selectedData && selectedData.expenseParentType) {
            setParentType(selectedData.expenseParentType);
            setExpenseIdValue(selectedData.id);
            setDeleteExpenseDialogOpen(true);
        }
    }

    const handleEditExpense = (index) => {
        let selectedData = muiData && muiData[index] ? muiData[index] : "";
        setExpenseIdValue(selectedData.id);
        if (selectedData && selectedData.id) {
            dispatchFetchSingleExpense(selectedData.id,
                () => {
                    logger.log("Single Vehicle Component Dweb", "Get single expense details successfull");
                    if (selectedData.expenseParentType == "fuel") {
                        setEditFuelExpense(true);
                    } else if (selectedData.expenseParentType == "maintenance") {
                        setEditMaintenanceExpense(true);
                    } else if (selectedData.expenseParentType == "other" || selectedData.expenseParentType == "driver") {
                        setEditDriverExpense(true);
                    }
                },
                () => {
                    logger.log("Single Vehicle Component Dweb", "Get single expense details failed");
                }
            );
        }
    }

    const handleDeleteClose = () => {
        setDeleteExpenseDialogOpen(false);
    }

    const handleExpenseConfirm = () => {
        setCurrentPageNo(defaultPageNo)
        let vehicleIdValue = vehicleId;

        var dateFilterValueUtil = getTripDateFilterValues();

        var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

        var PandLdata = {
            vehicleId: vehicleIdValue,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: vehicleIdValue,
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: [],
            tripStatus: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus],
            pageNo: defaultPageNo,
            pageSize: defaultPageSize,
        };

        let defaultDateFilterValue = "ALL_MONTHS";
        let defaultTripBookFilterValue = "All Trips & Expenses";

        dispatchGetSingleTruck(vehicleIdValue,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    let vehicleOwner = data && data.response && data.response.ownershipType ? data.response.ownershipType : {};
                    logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Successfull ");
                    dispatchGetPandL(PandLdata, defaultDateFilterValue,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Single Vehicle Component Dweb", "Get P and L report Successfull");
                                if (vehicleOwner == 'HIRED') {
                                    dispatchGetMarketTrukExpenses(expenseData, null,
                                        (data) => {
                                            if (data && data.status && data.status.code == 200) {
                                                logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");

                                            }
                                        },
                                        () => {
                                            logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                        },
                                    )
                                } else {
                                    dispatchGetTripExpenses(expenseData, null,
                                        (data) => {
                                            if (data && data.status && data.status.code == 200) {
                                                logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");

                                            }
                                        },
                                        () => {
                                            logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                                        },
                                    )
                                }
                            }
                        },
                        () => {
                            logger.log("Single Vehicle Component Dweb", "Get P and L report Failed");
                        },
                    )
                }
            },
            () => {
                logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Failed");
            }
        );
    }

    // Delete Truck Dialog Control.
    const handleDeleteTruckDialogClose = () => {
        setDeleteTruckDialog(false);
    }

    const handleDeleteTruckDialogOpen = () => {
        setDeleteTruckDialog(true);
    }

    const onDeleteTruck = () => {
        dispatchDeleteVehicle(vehicleId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single Vehicle Component Dweb", "Delete Truck Successfull");
                    setDeleteTruckDialog(false);
                    history.push({
                        pathname: '/trucks',
                        path: '/trucks',
                        pageTitle: 'Trucks',
                        visible: true,
                        state: {
                            id: 1,
                            pageTitle: 'Trucks'
                        },
                        name: 'Trucks',
                        type: 'submenu',
                    });
                }
            },
            () => {
                logger.log("Single Vehicle Component Dweb", "Delete Truck Failed");
            }
        )
    }
    // Delete Truck Dialog Control End.


    const handleDateValue = (value) => {
        if (value == "CUSTOM") {
            setCustomFilter(true);
        }
        else {
            setDateFilterValue(value);
            setCustomFilter(false);
            setCustomFilterValue({});
        }
        setChangeFlag(true);
    }

    const handleTripBookFilterValue = (value) => {
        setTripBookFilterValue(value);
        setChangeFlag(true);
    }

    const handleComingSoonClose = () => {
        setComingSoonModalOpen(false);
    }

    const handleBookClick = (value) => {
        var checkComingSoon = user && user.configs.coming_soon ? user.configs.coming_soon : "";
        if (value == "Trip Book") {
            if (checkComingSoon.TripBook_enabled == 0) {
                setName(value);
                setComingSoonModalOpen(true);
                setTripBookOpen(false);
            } else if (checkComingSoon.TripBook_enabled) {
                setComingSoonModalOpen(false);
                setTripBookOpen(true);
            }
        } else if (value == "Fuel Book") {
            if (checkComingSoon.FuelBook_enabled == 0) {
                setName(value);
                setComingSoonModalOpen(true);
                setFuelBookOpen(false);
            } else if (checkComingSoon.FuelBook_enabled) {
                setComingSoonModalOpen(false);
                setFuelBookOpen(true);
            }
        } else if (value == "Maintenance Book") {
            if (checkComingSoon.MaintenanceBook_enabled == 0) {
                setName(value);
                setComingSoonModalOpen(true);
                setMaintenanceBookOpen(false);
            } else if (checkComingSoon.MaintenanceBook_enabled) {
                setComingSoonModalOpen(false);
                setMaintenanceBookOpen(true);
            }
        } else if (value == "Driver & Other Expenses") {
            if (checkComingSoon.DriverAndOtherExpenses_enabled == 0) {
                setName(value);
                setComingSoonModalOpen(true);
                setDriverBookOpen(false);
            } else if (checkComingSoon.DriverAndOtherExpenses_enabled) {
                setComingSoonModalOpen(false);
                setDriverBookOpen(true);
            }
        }
        else if (value == "Documents") {
            if (checkComingSoon.DocumentBook_enabled == 0) {
                setName(value);
                setComingSoonModalOpen(true);
                setDocumentBookOpen(false);
            } else if (checkComingSoon.DocumentBook_enabled) {
                setComingSoonModalOpen(false);
                setDocumentBookOpen(true);
            }
        } else if (value == "EMI Book") {
            if (checkComingSoon.EmiBook_enabled == 0) {
                setName(value);
                setComingSoonModalOpen(true);
                setEmiBookOpen(false);
            } else if (checkComingSoon.EmiBook_enabled) {
                setComingSoonModalOpen(false);
                setEmiBookOpen(true);
            }
        } else if (value == "Diesel Card") {

            const fuelBrokerId = singleTruckData && singleTruckData.vehicleFuelCards && singleTruckData.vehicleFuelCards[0] && singleTruckData.vehicleFuelCards[0].brokerId ? singleTruckData.vehicleFuelCards[0].brokerId : ""

            if (!fuelBrokerId) {

                setFuelCardActivation(true);

            } else {
                history.push({
                    pathname: `/diesel-card/single-diesel-card/${singleTruckData && singleTruckData.id ? singleTruckData.id : ""}/${fuelBrokerId ? fuelBrokerId : ""}`,
                    state: {
                        id: 1,
                        pageTitle: "Diesel Card",
                        vehicleNumber: singleTruckData && singleTruckData.vehicleNumberArrayDweb ? singleTruckData.vehicleNumberArrayDweb : []
                    }
                })
            }
        }
        // setName(value);
        // setComingSoonModalOpen(true);
    }

    const handleFuelExpenseClose = () => {
        setEditFuelExpense(false);
        vehicle.singleExpenseDetails = {}
    }

    const handleMaintenanceExpenseClose = () => {
        setEditMaintenanceExpense(false);
        vehicle.singleExpenseDetails = {}
    }

    const handleDriverExpenseClose = () => {
        setEditDriverExpense(false);
        vehicle.singleExpenseDetails = {}
    }

    const handleTripBookClose = () => {
        setTripBookOpen(false);
    }

    const handleFuelBookClose = () => {
        setFuelBookOpen(false);
    }

    const handleMaintenanceBookClose = () => {
        setMaintenanceBookOpen(false);
    }

    const handleDriverBookClose = () => {
        setDriverBookOpen(false);
    }

    const handleDocumentBookClose = () => {
        setDocumentBookOpen(false);
    }

    const handleEmiBookClose = () => {
        setEmiBookOpen(false);
    }

    const handleCustomFilterClose = () => {
        setCustomFilter(false);
    }

    const handleCustomFilterConfirm = (value) => {
        setDateFilterValue("CUSTOM");
        setCustomFilter(false);
        setCustomFilterValue(value);
    }

    const handleMonthlyReports = () => {
        setMonthlyReportDialog(true);
    }

    const handleMonthlyReportsClose = () => {
        setMonthlyReportDialog(false);
    }

    const handleDriverDetailsClose = () => {
        setFuelCardActivation(false);
    }

    return (
        <>
            <Wrapper>
                <Paper className={classes.pageContentDIv} elevation={3}>
                    <div className={classes.divV1}>
                        <Grid container
                            justify="space-between"
                            alignItems="center">
                            {(singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED") &&
                                <Grid item>
                                    <div className={classes.divV2}>Supplier Name</div>
                                    <div className={classes.divV3}>{singleTruckData.vendor && singleTruckData.vendor.vendorName ? singleTruckData.vendor.vendorName : "N/A"}</div>
                                </Grid>
                            }
                            <Grid item>
                                <div className={classes.divV2}>Driver Name</div>
                                <div className={classes.divV3}>{singleTruckData.driverName ? singleTruckData.driverName : "N/A"}</div>
                            </Grid>
                            <Grid item>
                                <div className={classes.divV2}>Truck Details</div>
                                <div className={classes.divV4}>
                                    {singleTruckData && singleTruckData.vehicleDetailsDisplay && singleTruckData.vehicleDetailsDisplay.length > 0 ?
                                        (
                                            <>
                                                {singleTruckData && singleTruckData.vehicleDetailsDisplay && singleTruckData.vehicleDetailsDisplay.map((details, index) => (
                                                    <>
                                                        <span> {details} </span>
                                                        {((index == 0 && singleTruckData.vehicleDetailsDisplay.length >= 2) || (index == 1 && singleTruckData.vehicleDetailsDisplay.length >= 3)) &&
                                                            <FiberManualRecordIcon
                                                                className={classes.circleOnTrip}
                                                            ></FiberManualRecordIcon>
                                                        }
                                                    </>
                                                ))}
                                            </>
                                        ) : (
                                            <span>N/A</span>
                                        )
                                    }
                                </div>
                            </Grid>
                            <Grid item>
                                <div>
                                    <Button startIcon={<EditIcon className={classes.editIconColor} />} className={classes.editButton} variant="contained" onClick={() => handleEditVehicleOpen()}>
                                        Edit
                                    </Button>
                                    <Button startIcon={<DeleteIcon className={classes.deleteIconColor} />} className={classes.deleteButton} variant="contained" onClick={() => handleDeleteTruckDialogOpen()}>
                                        Delete Truck
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>

                    <div className={classes.divV5}>
                        <div className={classes.divV6}>
                            <div>
                                <div className={classes.filterHeading}>Date</div>
                                <DateFilter dateValue={handleDateValue} fromSingleVehicle={true} defaultValue={dateFilterValue} />
                            </div>
                            <div className={classes.mtV1}>
                                <div className={classes.filterHeading}>Filter</div>
                                {singleTruckData.ownershipType && singleTruckData.ownershipType != "HIRED" && <TripBookFilter tripBookFilterValueFunc={handleTripBookFilterValue} />}
                                {singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED" && <TripStatusFilter fromTripListing={true} status={handleTripStatusValue} defaultTripStatusFilter={selectedFilterStatus} />}
                            </div>
                        </div>
                        <div>
                            <Button variant="contained" startIcon={<PictureAsPdfIcon />} className={classes.monthlyReportButton} onClick={() => handleMonthlyReports()}>
                                Monthly Reports
                            </Button>
                        </div>
                    </div>

                    <div className={classes.divV7}>
                        <div className={classes.profitV1}>
                            <div className={classes.profitHeading}>Trip Revenue</div>
                            <div className={classes.profitValue1}>{pandl && (pandl.totalRevenue || pandl.totalRevenue == 0) ? numberFormat(pandl.totalRevenue) : numberFormat(0)}</div>
                        </div>

                        <div className={classes.profitV2}>
                            <div className={classes.profitHeading}>Total expenses</div>
                            <div className={classes.profitValue2}>{pandl && (pandl.totalExpenses || pandl.totalExpenses == 0) ? numberFormat(pandl.totalExpenses) : numberFormat(0)}</div>
                        </div>

                        <div className={classes.profitV2}>
                            <div className={classes.profitHeading}>Total Profit</div>
                            <div className={pandl && pandl.profit && pandl.profit > 0 ? classes.profitValue3 : classes.profitValue4}>{pandl && (pandl.profit || pandl.profit == 0) ? numberFormat(pandl.profit) : numberFormat(0)}</div>
                        </div>
                    </div>

                    {singleTruckData.ownershipType && singleTruckData.ownershipType != "HIRED" && <div className={classes.divV8}>
                        <Grid container direction="row" justify="space-between" >
                            <Grid item classes={{ item: classes.taV1 }} onClick={() => handleBookClick("Trip Book")}>
                                <div className={classes.divTripIcon}>
                                    <TripBookIconDweb className={classes.tripIcon} />
                                </div>
                                <div className={classes.iconText}>Trip Book</div>
                            </Grid>
                            <Grid item classes={{ item: classes.taV1 }} onClick={() => handleBookClick("Fuel Book")}>
                                <div className={classes.divFuelIcon}>
                                    <FuelBookIconDweb className={classes.fuelIcon} />
                                </div>
                                <div className={classes.iconText}>Fuel Book</div>
                            </Grid>
                            <Grid item classes={{ item: classes.taV1 }} onClick={() => handleBookClick("EMI Book")}>
                                <div className={classes.divEmiIcon}>
                                    <EmiBookIconDweb className={classes.emiIcon} />
                                </div>
                                <div className={classes.iconText}>EMI Book</div>
                            </Grid>
                            <Grid item classes={{ item: classes.taV1 }} onClick={() => handleBookClick("Documents")}>
                                <div className={classes.divDocumnetIcon}>
                                    <DocumnetsIconDweb className={classes.documnetIcon} />
                                </div>
                                <div className={classes.iconText}>Documents</div>
                            </Grid>
                            <Grid item classes={{ item: classes.taV1 }} onClick={() => handleBookClick("Maintenance Book")}>
                                <div className={classes.divMaintenanceIcon}>
                                    <MaintenanceBookIconDweb className={classes.maintenanceIcon} />
                                </div>
                                <div className={classes.iconText}>Maintenance<div>Book </div></div>
                            </Grid>
                            <Grid item classes={{ item: classes.taV1 }} onClick={() => handleBookClick("Driver & Other Expenses")}>
                                <div className={classes.divDriverIcon}>
                                    <DriverIconDweb className={classes.driverIcon} />
                                </div>
                                <div className={classes.iconText}>Driver & Other <div>expenses</div></div>
                            </Grid>
                            <Grid item classes={{ item: classes.taV1 }} onClick={() => handleBookClick("Diesel Card")}>
                                <div className={classes.divDieselIcon}>
                                    <FuelBunkGreen className={classes.fuelBunkIcon} />
                                </div>
                                <div className={classes.iconText}>Diesel <div>Card</div></div>
                            </Grid>

                            {/* <Grid item classes={{ item: classes.taV1 }} onClick={() => handleBookClick("Trip & Expenses")}>
                                <div className={classes.divTripsAndExpenses}>
                                    <TripsAndExpensesDweb className={classes.tripsAndExpensesIcon} />
                                </div>
                                <div className={classes.iconText}>Trips & <div>Expenses</div></div>
                            </Grid> */}
                        </Grid>
                    </div>}
                    <div className={singleTruckData.ownershipType && singleTruckData.ownershipType == "HIRED" ? classes.vehicleTableV1 : classes.vehicleTable}>
                        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                    </div>
                </Paper>

            </Wrapper>


            {/* Delete Truck Dialog. */}
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={deleteTruckDialog} onClose={handleDeleteTruckDialogClose}
            >
                <DialogContent className={classes.dcV1}>
                    <div>Are you sure you want to delete the truck <span className={classes.spanV1}>{singleTruckData.vehicleNumber}</span></div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteTruckDialogClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDeleteTruck}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>
            {editVehicleOpen && <EditTruck open={editVehicleOpen} vehicleId={singleTruckData.id} vehicleDetails={singleTruckData} onClose={handleEditVehicleClose} onSave={handleVehicleUpdate} />}
            {comingSoonModalOpen && <ComingSoonModal open={comingSoonModalOpen} featureName={name} onClose={handleComingSoonClose} />}
            {deleteExpenseDialogOpen && <DeleteExpenseDialog open={deleteExpenseDialogOpen} onClose={handleDeleteClose} onConfirm={handleExpenseConfirm} expenseParentType={parentType} expenseId={expenseIdValue} />}
            {editFuelExpense && <AddFuelExpenseDialog open={editFuelExpense} onClose={handleFuelExpenseClose} onConfirm={handleExpenseConfirm} fuelExpenseData={singleExpenseDetails} edit={true} expenseId={expenseIdValue} />}
            {editMaintenanceExpense && <AddMaintainanceExpenseDialog open={editMaintenanceExpense} onClose={handleMaintenanceExpenseClose} onConfirm={handleExpenseConfirm} maintenanceExpenseData={singleExpenseDetails} edit={true} expenseId={expenseIdValue} />}
            {editDriverExpense && <AddDriverExpenseDialog open={editDriverExpense} onClose={handleDriverExpenseClose} onConfirm={handleExpenseConfirm} driverExpenseData={singleExpenseDetails} edit={true} expenseId={expenseIdValue} />}
            {tripBookOpen && <TripBook open={tripBookOpen} onClose={handleTripBookClose} />}
            {fuelBookOpen && <FuelBook open={fuelBookOpen} onClose={handleFuelBookClose} />}
            {maintenanceBookOpen && <MaintenanceBook open={maintenanceBookOpen} onClose={handleMaintenanceBookClose} />}
            {driverBookOpen && <DriverBook open={driverBookOpen} onClose={handleDriverBookClose} />}
            {documentBookOpen && <DocumentBook openBook={documentBookOpen} onClose={handleDocumentBookClose} />}
            {emiBookOpen && <EmiBook openBook={emiBookOpen} onClose={handleEmiBookClose} vehicleNumber={singleTruckData.vehicleNumber} vehicleBodyType={singleTruckData.vehicleBodyType} />}
            {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}
            {monthlyReportDialog && <SingleVehicleMonthlyReport vehicleIdValue={vehicleId} open={monthlyReportDialog} onClose={handleMonthlyReportsClose} singleTruck={singleTruckData} />}
            {fuelCardActivation && <DriverDetailsDialog open={fuelCardActivation} onClose={handleDriverDetailsClose} truckInfo={singleTruckData} fromSingleTruck={true} />}
        </>
    );

}

const mapStateToProps = (state) => ({
    vehicle: state.vehicle,
    user: state.user
});
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
    dispatchDeleteVehicle: (id, onSuccess, onFailure) => { dispatch(deleteVehicle(id, onSuccess, onFailure)) },
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
    dispatchGetMarketTrukExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(marketVehicleExpenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
    dispatchVehicleTypesConfig: (onSuccess, onFailure) => dispatch(getAllVehicleTypeConfigs(null, onSuccess, onFailure)),
    dispatchFetchSingleExpense: (expenseId, onSuccess, onFailure) => dispatch(FetchExpenseDetails(expenseId, onSuccess, onFailure)),

});
const SingleVehicleWithRouter = withRouter(SingleVehicle);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SingleVehicleWithRouter);
